import request from "superagent";

export const GET_LOCALE = "localization/GET_LOCALE";
export const GET_LOCALE_DATA_RECEIVED = "localization/GET_LOCALE_DATA_RECEIVED";
export const GET_LOCALE_ERROR = "localization/GET_LOCALE_ERROR";

export default function localizationServiceFactory(store, next, action) {
  return {
    [GET_LOCALE]: () => {
      request
        .get(
          "/locales/" +
            action.locale.replace(/_/g, "-").toLowerCase() +
            "/common.json"
        )
        .end((err, res) => {
          if (err) {
            return next({
              type: GET_LOCALE_ERROR,
              err: err
            });
          }

          const data = res.body;

          return next({
            type: GET_LOCALE_DATA_RECEIVED,
            locale: action.locale,
            data: data
          });
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/localization.js